﻿import document from 'document';
import { eventBus } from '../../foundation/eventBus';

export const events = {
    offCanvasNav: 'offCanvasNav',
};

export const burgerMenu = () => {
    const selectors = {
        menuOpen: 'burger-menu--open',
        canvasContainer: '.canvas-overlay'
    };

    const init = component => {
        const handleClick = () => {
            component.classList.toggle(selectors.menuOpen);            
            eventBus.publish(events.offCanvasNav);
        };

        const overlay = document.querySelector(selectors.canvasContainer);

        component.addEventListener('click', handleClick);
        overlay.addEventListener('click', handleClick);
    };

    return {
        init: init,
        selector: '.burger-menu'
    };
};